import styled from 'styled-components'

import { theme } from '@app/utils/theme'

export const ActionLink = styled.a`
  font-size: 0.9rem;
  color: ${theme.colors.up};

  &:hover {
    text-decoration: underline;
    color: ${theme.colors.over};
  }
`
